import axios, { AxiosPromise } from 'axios';
import { Promise } from 'es6-promise';

import * as Api from './Api';
import { Utilities } from './Utilities';

export const Create = function(
  deviceId: string,
  dl: Api.DeliveryLocation,
): AxiosPromise {
  const data = {
    deviceId,
    Coordinates: dl.Coordinates,
    Building: dl.Building,
    Street: dl.Street,
    Town: dl.Town,
    PostCode: dl.PostCode,
    DeliveryInstructions: dl.DeliveryInstructions,
    IsCustomAddress: dl.IsCustomAddress,
  };
  return axios.post('/Map/DeliveryLocation', data);
};

export const LoadPrevious = function(
  deviceId: string,
): Promise<Api.DeliveryLocationResponse> {
  return Utilities.toPromise<Api.DeliveryLocationResponse>(
    axios.get('/Map/DeliveryLocations', {
      params: {
        deviceId,
      },
    }),
  );
};
